import { Button, Icon, Stack } from "@storoey/sui";
import { JSX } from "solid-js/jsx-runtime";

export const PhotoPickButtons = (props: { onPhoto: (blob: File) => void }) => {
  let cameraCaptureRef: HTMLInputElement | null = null;
  let photoSelectRef: HTMLInputElement | null = null;

  const pickPhoto = () => {
    if (photoSelectRef) {
      photoSelectRef.click();
    }
  };

  const captureCamera = () => {
    if (cameraCaptureRef) {
      cameraCaptureRef.click();
    }
  };

  const handleChange: JSX.EventHandler<HTMLInputElement, Event> = (event) => {
    const file = event.currentTarget.files?.[0];

    if (!file) {
      return;
    }

    props.onPhoto(file);
  };

  return (
    <Stack direction="row" align="center">
      <Button
        leftIcon={<Icon>photo_camera</Icon>}
        variant="outline"
        onClick={captureCamera}
      ></Button>
      <Button
        leftIcon={<Icon>upload</Icon>}
        variant="outline"
        onClick={pickPhoto}
      ></Button>

      <input
        style={{ display: "none" }}
        ref={(r) => (photoSelectRef = r)}
        type="file"
        accept="image/*"
        onChange={handleChange}
      />

      <input
        style={{ display: "none" }}
        ref={(r) => (cameraCaptureRef = r)}
        type="file"
        accept="image/*"
        capture="environment"
        onChange={handleChange}
      />
    </Stack>
  );
};
